import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    // Check if the user is authenticated
    if (!this.authenticationService.auth.token) {
      this.router.navigate(['/login']);
      return false;
    }
    const response = await this.authenticationService.checkAuthentication() as any;
    if (!response.success) {
      this.router.navigate(['/login']);
      return false;
    }
    // Get user role from cookie
    const userAssignedRole = this.authenticationService.auth.role.slug;
    // Get allowed roles from route data
    const allowedRoles = route.data['roles'] || [];
    // Check if user role is in allowed roles
    if (allowedRoles.includes(userAssignedRole)) {
      return true;
    }
    if (userAssignedRole.includes('stakeholder_')) {
      this.router.navigate(['/contributors']);
      return false;
    }
    this.router.navigate(['/403']);
    return false;
  }
}